import { render } from "./MapImage.vue?vue&type=template&id=646b7659"
import script from "./MapImage.vue?vue&type=script&lang=ts"
export * from "./MapImage.vue?vue&type=script&lang=ts"
script.render = render

export default script